export default {"src":"/_next/static/media/kominfo.956c461c.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};